import * as React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { Head } from './Head';
import { Body } from './Body';
import Table from '../Table';
import { ITemplateData } from '../../entities/table';
import Toolbar from './Toolbar';
import { useNavigate } from 'react-router-dom';
import { IState } from '../../lib/store';
import { isSystemAdmin } from '../../lib/helper';

interface IProps {
  rows: ITemplateData[],
}

export const TemplatesTable: React.FC<IProps> = ({rows}) => {
  const navigate = useNavigate();
  const user = useSelector((state: IState) => state.auth.profile, shallowEqual)!;
  const isAuthorized = isSystemAdmin(user.id);
  
  return <Table Head={Head} Body={Body} rows={rows} Toolbar={() => <Toolbar goToNewTemplate={() => navigate('new')} showNewButton={isAuthorized} />}/>;
}
